import axios from 'axios/index';
import store from '../../../';

export default {
    namespaced: true,
    state: {
        mode: '',
        indexComponent: -1,
        currentStory: {},
        storyTypes: [],
        defaultStory: {
            listItem: [],
            templateType: 'Blinkl Stories',
            version: '1.1'
        }
    },

    getters: {
        mode: (state) => state.mode,
        defaultStory: (state) => state.defaultStory,
        storyTypes: (state) => state.storyTypes
    },

    mutations: {
        MODE_RESET_STORY: (state) => {
            state.mode = '';
            state.indexComponent = -1;
        },
        STORY_UPDATE_STYLE: (state, value) => {
            state.currentStory.templateType = value;
        },
        STORY_SET_LIST_STYLE: (state, value) => {
            state.storyTypes = value;
        },
        STORY_ADD_COMPONENT: (state, data) => {
            if (data.index !== undefined) {
                state.currentStory.listItem.splice(data.index, 0, data.component);
            } else {
                state.currentStory.listItem.push(data.component);
            }
        },
        STORY_UPDATE_COMPONENT: (state, data) => {
            state.currentStory.listItem[data.index] = data.data;
        },
        STORY_TRY_DELETE_COMPONENT: (state, index) => {
            state.mode = 'deleteComponent';
            state.indexComponent = index;
        },
        STORY_DELETE_COMPONENT: (state) => {
            state.currentStory.listItem.splice(state.indexComponent, 1);
        },
        STORY_UPDATE_LIST_ITEM: (state, value) => {
            state.currentStory.listItem = value;
        },
        CLEAN_CURRENT_DATA: (state) => {
            state.currentStory = {};
        }
    },

    actions: {
        modeResetStory: function (localStore) {
            localStore.commit('MODE_RESET_STORY');
        },
        getStoryTypes: function (localStore) {
            return new Promise(function (resolve, reject) {
                axios.get('/templates').then((response) => {
                    localStore.commit('STORY_SET_LIST_STYLE', response.data);
                    resolve(response.data);
                }, (err) => {
                    reject(err);
                });
            });
        },
        updateStoryStyle: function (localStore, data) {
            return new Promise(function (resolve, reject) {
                let value = { ...localStore.state.currentStory };
                value.templateType = data;
                store.dispatch('actions/updateActionData', value).then(() => {
                    localStore.commit('STORY_UPDATE_STYLE', data);
                    resolve();
                }).catch((err) => {
                    reject(err);
                });
            });
        },
        storyAddComponent: function (localStore, data) {
            localStore.commit('STORY_ADD_COMPONENT', data);
        },
        storyTryDeleteComponent: function (localStore, index) {
            localStore.commit('STORY_TRY_DELETE_COMPONENT', index);
        },
        storyDeleteComponent: function (localStore) {
            localStore.commit('STORY_DELETE_COMPONENT');
            localStore.commit('MODE_RESET_STORY');
        },
        storyUpdateComponent: function (localStore, data) {
            localStore.commit('STORY_UPDATE_COMPONENT', data);
        },
        storyUpdate: function (localStore) {
            return new Promise(function (resolve, reject) {
                store.dispatch('actions/updateActionData', { ...localStore.state.currentStory })
                    .then(() => {
                        resolve();
                    }).catch((err) => {
                        reject(err);
                    });
            });
        }
    }
};
